/** @returns Whether the current window is in iframe. */
export function isIframe(): boolean {
  try {
    return window.self !== window.top
  } catch (e) {
    return false
  }
}
